<div class="container">
  <div class="row">
    <div class="col-md-10">
      <div class="panel panel-table">
        <div class="panel-heading">
          <h3 class="panel-title">DGX {{title}}</h3>
        </div>
        <form [formGroup]="form" *ngIf="ErrorResponse">
          <div class="col-md-offset-11 col-md-1 format"><button tabindex=0 role=button class="btn btn-primary"
              (click)="backClicked();">Back</button></div>
          <div class="form-group">
            <div>
              <div>Error Parsing The Request:</div>
              <div>Code: {{code}}</div>
              <div>Msg: {{msg}}</div>
              <div>Line: {{line}}</div>
              <div>Validating against the schema</div>
            </div>
            <textarea aria-label ="Route XML content" formControlName="routeXmlContent" style="resize: none;" rows="50" readonly
              class="form-control">{{routeXmlResponse}}</textarea>
          </div>
        </form>
        <div class="panel-body" *ngIf="!ErrorResponse">
          <div class="col-md-offset-11 col-md-1 format"><button tabindex=0 role=button class="btn btn-primary"
              (click)="backClicked();">Back</button></div>
              <div *ngIf="isLoading"><div class="spinner"></div></div>
          <div class="col-md-12">
            <div>
              <table class="table"   *ngIf="!isLoading">
                <tr>
                  <td width="60%"><strong class="column-heading">Element Name</strong></td>
                  <td width="20%" class="column-heading"><strong class="column-heading">Response
                      Value</strong>
                  </td>
                </tr>
              </table>
            </div>
            <table class="table">
              <tbody *ngFor="let item of  htmlOutputItems | keyvalue;">
                <tr class="border">
                  <td width="60%" [innerHTML]='item.key'>{{item.key}}</td>
                  <td width="20%">{{item.value}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
